exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tui-editor-contents {\r\n  font-size: 1.2em;\r\n  font-family: \"Gudea\", sans-serif !important;\n}\r\n", ""]);

